module.exports = {"TXTWCL_Responsible_gaming":{"id":"TXTWCL_Responsible_gaming","defaultMessage":"Responsible gaming","track":"Responsible gaming"}}